var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50443 22.2301C3.44785 15.8093 5.85135 8.47037 12.5923 6.29878C16.1381 5.15453 20.0519 5.8292 22.9998 8.04678C25.7885 5.89053 29.8461 5.1622 33.3881 6.29878C40.129 8.47037 42.5478 15.8093 40.4932 22.2301C37.2923 32.4076 22.9998 40.2468 22.9998 40.2468C22.9998 40.2468 8.8126 32.5265 5.50443 22.2301Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 12.8418C32.7175 13.505 34.1665 15.3354 34.3409 17.484",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.42ebaf71cdb0ae2274488c3a09126fa9.svg";
export { ForwardRef as ReactComponent };